import { LoadingOverlay, Box, Group, Button, TextInput } from '@mantine/core';

import { useConfigEmail } from '../hooks/use-config-email';

export const Email = () => {
  const {
    form,
    isLoading,
    handleSubmit,
  } = useConfigEmail();

  return (
    <Box style={{ position: 'relative' }}>
      <LoadingOverlay
        visible={isLoading}
        overlayProps={{ blur: 2 }}
      />

      <form onSubmit={form.onSubmit(handleSubmit)}>
        <TextInput
          label="SMTP address"
          withAsterisk
          key={form.key('smtpAddress')}
          {...form.getInputProps('smtpAddress')}
        />
        <TextInput
          label="SMTP port"
          withAsterisk
          key={form.key('smtpPort')}
          {...form.getInputProps('smtpPort')}
        />
        <TextInput
          label="Логин"
          withAsterisk
          key={form.key('login')}
          {...form.getInputProps('login')}
        />
        <TextInput
          label="Пароль"
          withAsterisk
          key={form.key('password')}
          {...form.getInputProps('password')}
        />
        <TextInput
          label="Email proxy URL"
          withAsterisk
          key={form.key('emailProxyUrl')}
          {...form.getInputProps('emailProxyUrl')}
        />

        <Group justify="flex-start" mt="30">
          <Button type="submit" loading={isLoading}>
            Сохранить
          </Button>
        </Group>
      </form>
    </Box>
  );
};
